import { Breadcrumb, Page, useEntity } from 'components';
import { ReactElement } from 'react';
import invariant from 'tiny-invariant';
import type { BlockDetails } from '../types';
import { ObjectTaskList } from 'modules/tasks/ObjectTaskList/ObjectTaskList';
export function Tasks(): ReactElement {
  const { item, mutate } = useEntity<BlockDetails>();

  return (
    <Page narrow>
      <Breadcrumb>Tasks</Breadcrumb>
      <ObjectTaskList
        taskList={item.task_list}
        onTaskListUpdate={(task_list) => {
          mutate((block) => {
            invariant(block);
            return { ...block, task_list };
          });
        }}
      />
    </Page>
  );
}
